/*
 * Offerta PageFly (pagina pf-9d685f6e) -> carrello -> checkout.
 * Sostituisce lo script in coda al file PageFly senza toccarlo: il clic sul
 * bottone giallo viene intercettato qui PRIMA che arrivi al vecchio listener,
 * quindi una ripubblicazione da PageFly (che lo tenga o lo cancelli) non cambia
 * niente. Usa gli id/classi che il precedente sviluppatore ha messo in PageFly:
 *   #btn-buy-now, .custom-product-choice#product-offer-a|b|c, .custom-color#color-*
 * Caricato da layout/theme.liquid su ogni pagina PageFly (suffisso pf-): se la
 * pagina viene ricreata con un id nuovo, lo script la segue lo stesso.
 * Ennovative, 10-2026.
 */
(function () {
  'use strict';

  // bundle|colore -> variante (identiche allo script originale)
  var VARIANTI = {
    'product-offer-a|color-black': 48748072141065,
    'product-offer-a|color-forest-green': 55847559233801,
    'product-offer-a|color-white': 48748072108297,
    'product-offer-a|color-military-green': 55847559266569,
    'product-offer-a|color-beige': 55847559299337,
    'product-offer-b|color-black': 48748007620873,
    'product-offer-b|color-forest-green': 55847560118537,
    'product-offer-b|color-white': 48748007588105,
    'product-offer-b|color-military-green': 55847560151305,
    'product-offer-b|color-beige': 55847560184073,
    'product-offer-c|color-black': 55844919443721,
    'product-offer-c|color-forest-green': 55847562281225,
    'product-offer-c|color-white': 55847562313993,
    'product-offer-c|color-military-green': 55847562346761,
    'product-offer-c|color-beige': 55847562379529
  };

  // quanto aspettare che il carrello laterale si apra prima del piano di emergenza
  var ATTESA_CARRELLO_MS = 1500;

  // Selezione bundle/colore: la teniamo anche qui, cosi' funziona pure se una
  // ripubblicazione cancella lo script vecchio. Se c'e' ancora, fanno la stessa
  // cosa due volte: risultato identico.
  function selezione(gruppo) {
    document.addEventListener('click', function (e) {
      var box = e.target.closest(gruppo);
      if (!box) return;
      document.querySelectorAll(gruppo).forEach(function (b) { b.classList.remove('selected'); });
      box.classList.add('selected');
    });
  }
  selezione('.custom-product-choice');
  selezione('.custom-color');

  function alCheckout() { window.location.href = '/checkout'; }

  /* ---------- carrello laterale: Snap Cart (SnapSell / WizzCommerce) ----------
   * Verificato sul tema di prova l'08-10-2026: Snap Cart espone
   * window.openSnapCart() e si apre anche da solo quando un prodotto entra nel
   * carrello via /cart/add.js. Il pannello e' #wizz4-cart-drawer e da aperto ha
   * la classe wizz4-visible. Se l'app viene disattivata o cambia, apriCarrello()
   * o carrelloAperto() rispondono false e scatta il piano di emergenza.
   * (Il carrello fatto da noi, alternativa senza app, e' nel commit 7ad51ad.) */

  function apriCarrello() {
    if (typeof window.openSnapCart !== 'function') return false;
    try { window.openSnapCart(); } catch (e) { console.error('[offerta] Snap Cart', e); return false; }
    return true;
  }

  function carrelloAperto() {
    var pannello = document.getElementById('wizz4-cart-drawer');
    return !!pannello && pannello.classList.contains('wizz4-visible');
  }

  // articoli = [{ id: variante, quantity: n }, ...]
  // link carrello di Shopify: porta al checkout con esattamente questi articoli
  function alPermalink(articoli) {
    var sconto = window.ENNOVATIVE_SCONTO ? '?discount=' + encodeURIComponent(window.ENNOVATIVE_SCONTO) : ''; // pagina Black Friday
    window.location.href = '/cart/' + articoli.map(function (a) { return a.id + ':' + a.quantity; }).join(',') + sconto;
  }

  function aggiungi(articoli) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: articoli })
    }).then(function (r) {
      return r.json().then(function (dati) {
        if (!r.ok) {
          var errore = new Error(dati.description || dati.message || 'aggiunta non riuscita');
          errore.daShopify = true;
          throw errore;
        }
        return dati;
      });
    });
  }

  // Piano di emergenza, in due tempi:
  // 1) il carrello laterale deve APRIRSI entro ATTESA_CARRELLO_MS, altrimenti
  //    checkout come una volta. Conta solo la prima apertura: se poi il cliente
  //    lo chiude per continuare a guardare la pagina, resta dov'e'. (Prima del
  //    09-10-2026 il controllo guardava se era aperto in quel momento e mandava
  //    al checkout chi lo aveva appena chiuso.)
  // 2) aperto ma SENZA il prodotto -> lo rimette, una volta sola. Visto
  //    l'08-10-2026: carrello svuotato e clic subito dopo, 1 volta su 3 la
  //    sincronizzazione di Snap Cart toglieva il prodotto appena aggiunto. Niente
  //    redirect dopo: se manca ancora, puo' averlo tolto il cliente dal carrello.
  // Il prodotto si rimette solo se lo ha tolto Snap, non il cliente: un tocco
  // dentro il carrello (rimuovi, quantita', chiudi) dopo l'aggiunta vuol dire
  // che ci sta lavorando lui. Visto il 09-10-2026: senza questo, chi rimuoveva
  // il bundle entro 2-3 secondi se lo ritrovava nel carrello.
  var ultimoTocco = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest('#wizz4-cart-drawer, #wizz4-cart-drawer-background')) ultimoTocco = Date.now();
  }, true);

  // conta solo l'ultima aggiunta: un nuovo clic annulla i controlli in sospeso
  var giro = 0;

  function attendiApertura(articoli) {
    var questo = ++giro;
    var inizio = Date.now();
    (function guarda() {
      if (questo !== giro) return;
      if (carrelloAperto()) return setTimeout(function () { controllaProdotti(articoli, questo, inizio); }, ATTESA_CARRELLO_MS);
      if (Date.now() - inizio > ATTESA_CARRELLO_MS) return alCheckout();
      setTimeout(guarda, 150);
    })();
  }

  function controllaProdotti(articoli, questo, inizio) {
    if (questo !== giro || ultimoTocco > inizio) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (carrello) {
        if (questo !== giro || ultimoTocco > inizio) return;
        var presenti = carrello.items.map(function (it) { return it.variant_id; });
        var mancanti = articoli.filter(function (a) { return presenti.indexOf(a.id) < 0; });
        if (!mancanti.length) return;
        console.warn('[offerta] prodotto sparito dal carrello, lo rimetto', mancanti);
        return aggiungi(mancanti).then(function () { apriCarrello(); });
      })
      .catch(function (err) { console.error('[offerta] controllo carrello', err); });
  }

  // Per gli altri bottoni del tema che aggiungono da soli al carrello (sezione
  // portable-coffee-maker4): dopo l'aggiunta chiamano questa. true = carrello
  // laterale avviato e sorvegliato; false = fai come prima (redirect).
  window.EnnovativeCarrello = {
    dopoAggiunta: function (articoli) {
      if (!apriCarrello()) return false;
      attendiApertura(articoli);
      return true;
    }
  };

  var inCorso = false;
  // tornando indietro dal checkout il browser ripristina la pagina com'era
  // (bfcache): senza questo il bottone resterebbe bloccato su "in corso"
  window.addEventListener('pageshow', function () { inCorso = false; });

  // fase di cattura sul document: arriva prima del listener sul bottone
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#btn-buy-now')) return;
    e.preventDefault();
    e.stopPropagation(); // il vecchio script non scatta piu'
    if (inCorso) return; // doppio tocco
    inCorso = true;

    var offerta = document.querySelector('.custom-product-choice.selected');
    var colore = document.querySelector('.custom-color.selected');
    var variante = offerta && colore && VARIANTI[offerta.id + '|' + colore.id];
    if (!offerta || !colore) {
      inCorso = false;
      alert('Scegli il colore e l\'offerta, poi riprova.');
      return;
    }
    if (!variante) {
      // bundle o colore aggiunto in PageFly ma non ancora nella tabella VARIANTI
      inCorso = false;
      console.error('[offerta] combinazione senza variante:', offerta.id, colore.id);
      alert('Questa combinazione non è disponibile al momento. Scegline un\'altra.');
      return;
    }

    var articoli = [{ id: variante, quantity: 1 }];
    aggiungi(articoli)
      .then(function () {
        inCorso = false;
        if (!window.EnnovativeCarrello.dopoAggiunta(articoli)) alCheckout();
      })
      .catch(function (err) {
        inCorso = false;
        console.error('[offerta]', err);
        if (err.daShopify) {
          // Shopify ha rifiutato (es. variante esaurita): dirlo, non mandare a un checkout vuoto
          alert(err.message);
        } else {
          // rete o risposta illeggibile: il link carrello di Shopify porta al checkout col prodotto
          alPermalink(articoli);
        }
      });
  }, true);
})();
